import React, { useEffect, useState } from "react"
import { Button, Dimmer, Grid, Icon, Image, Segment } from "semantic-ui-react"
import { GameStaticData } from "../../../StaticData/GameStaticData"
import './gameSection.scss'
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { ShowGameLink } from "../../../Actions/componentActions"
import GameVideo from "../../gameVideo/GameVideo"
import axios from "axios"
import { callingToSendGamesCompleted } from "../../../Services/AssessementQuestionsServices"
import { getProfileDetail } from "../../../Actions/ProfileAction"
import { setGamesData } from "../../../Actions/GameDetailsAction/gamesDetailsAction"

let gamesName = {
    'Parts Shop': 'match',
    'Circuit Boards': 'slide',
    'Assembly Line': 'stack'
}
const GameSection = (props) => {
    let { redirectUrl } = props
    const [activeTab, setActiveTab] = useState('awaiting')
    const [isLoading, setIsLoading] = useState(false)
    // const [rendergamesData, setrendergamesData] = useState(GameStaticData)
    const [hasActiveCard, setHasActiveCard] = useState('')
    // const [gamesData, setGamesData] = useState([])
    const { profileReducer, gamesDetailsReducer } = useSelector(state => state)
    const profileDetail = profileReducer?.profileDetail?.data?.user
    const { games: rendergamesData } = gamesDetailsReducer
    const dispatch = useDispatch()
    const [gameCompletionStatus, setGameCompletionStatus] = useState([])
    const generateGameUrl = (uid, gameId, role) => {
        switch (role) {
            case 'game3Status':
                return `${process.env.REACT_APP_GAMES_URL}/CensioApi/api/GetGame${gameId}GameCompletion?OrgId=1&GameId=${gameId}&UID=${uid}`;
            case 'gameStatus':
            default:
                return `${process.env.REACT_APP_GAMES_URL}/CensioApi/api/GetUserGame${gameId}Status?UID=${uid}&IDGAME=${gameId}`;
        }
    };

    const uid = profileDetail?.id

    useEffect(() => {
        setIsLoading(true)
        if (uid) {
            const fetchData = async () => {
                setIsLoading(true)
                try {
                    let gameUrls = [
                        // generateGameUrl(uid, 1, 'gameStatus'),
                        // generateGameUrl(uid, 2, 'gameStatus'),
                        // generateGameUrl(uid, 3, 'game3Status'),
                        generateGameUrl(uid, 4, 'gameStatus'),
                        generateGameUrl(uid, 5, 'gameStatus')
                    ].map(url => axios.get(url));
                    let game_completion = profileDetail?.game_completion

                    // Make multiple API requests concurrently using Promise.all
                    const gamePromises = await Promise.all(gameUrls);
                    let gameResponses = await gamePromises.map(response => response.data)
                    setGameCompletionStatus(gameResponses)
                    let normalizedGameCompletion = {};
                    for (let key in game_completion) {
                        if (game_completion.hasOwnProperty(key)) {
                            normalizedGameCompletion[key.toLowerCase()] = game_completion[key] === 'Completed';
                        }
                    }
                    let gamecompletedStatusData = []

                    for (const data of gameResponses) {
                        let findGame = [...GameStaticData].find(item => item?.idGame === data?.idGame) || {}
                        normalizedGameCompletion[findGame?.gamename] = data?.gamecompleted === 1
                        
                        if (findGame.gamename && !game_completion[findGame?.gamename] && data?.gamecompleted) {
                            gamecompletedStatusData.push({
                                [findGame.gamename]: 'Completed'
                            })
                        }
                    }

                    if (gamecompletedStatusData.length) {
                        await callingToSendGamesCompleted(gamecompletedStatusData)
                        dispatch(getProfileDetail())
                    }

                    let setGameStatus = [...GameStaticData]
                        .map((gameObj) => {
                            let findGame = (normalizedGameCompletion?.[gameObj?.gamename] || normalizedGameCompletion?.[gamesName?.[gameObj?.gamename]]) ? { gamecompleted: true } : { gamecompleted: false }
                            return {
                                ...gameObj,
                                ...findGame
                            }
                        })
                    dispatch(setGamesData(setGameStatus));
                    // let renderGames = setGameStatus.filter(gameobj => activeTab === 'completed' ? gameobj?.gamecompleted : !gameobj?.gamecompleted)
                    // setrendergamesData(setGameStatus)
                } catch (error) {
                    console.log('Error fetching data:', error.response);
                } finally {
                    setIsLoading(false)
                }
            };

            if (!gameCompletionStatus.length) {
                fetchData();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uid])



    const handleTabChange = (tab) => {
        // let renderGames = gamesData.filter(gameobj => tab === 'completed' ? gameobj?.gamecompleted : !gameobj?.gamecompleted)
        // setrendergamesData(renderGames)
        setActiveTab(tab)
    }


    return (
        <Grid className="game-section">
            <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div className="game__tab-row">
                        <Button
                            onClick={() => handleTabChange('awaiting')}
                            className={activeTab === "awaiting" ? "active__game-tab" : "inactive__game-tab"}
                            color='grey'
                        >
                            <Icon name="sync" />Awaiting Your Action
                        </Button>
                        {/* <Button
                            onClick={() => handleTabChange('completed')}
                            className={activeTab === "completed" ? "active__game-tab" : "inactive__game-tab"}
                            color='grey'
                        >
                            <Icon name="check circle" />Completed
                        </Button> */}
                    </div>
                    <div className="flex gap-2 flex-wrap">
                        {
                            isLoading ?
                                [...Array(3)].map((game, index) => {
                                    return (
                                        <div className={`w-full md:w-[29%] m-[1%] inline-block relative game-card-section bg-white shadow-sm rounded-sm transition-all duration-150 ease-in-out`} key={index} >
                                            <Dimmer.Dimmable as={Segment} dimmed={isLoading}>
                                                <Dimmer active={isLoading} inverted />
                                                <p>
                                                    <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
                                                </p>
                                            </Dimmer.Dimmable>
                                        </div>
                                    )
                                })
                                : rendergamesData.length > 0 ? rendergamesData.map((game, index) => {
                                    return (
                                        <React.Fragment key={`rander-game-${index}`}>
                                            <GameCard game={game} type={activeTab} redirectUrl={redirectUrl} setHasActiveCard={setHasActiveCard} hasActiveCard={hasActiveCard} />
                                        </React.Fragment>
                                    )
                                }) : <>
                                    <Grid.Column mobile={8} tablet={4} computer={4} className="vt-center" style={{ margin: "auto" }}>
                                        <div className="container-center">
                                            <p>No Record</p>
                                        </div>
                                    </Grid.Column>
                                </>
                        }
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}

export default GameSection;

const GameCard = (props) => {
    let { game, type, redirectUrl, hasActiveCard } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const [GameVideoPopUp, setGameVideoPopup] = useState(false);
    const isUdcUser = useSelector((state) => state.profileReducer?.profileDetail?.data?.user?.udc_user);

    const ssoToken = localStorage.getItem('ssoToken') || sessionStorage.getItem('ssoToken');

    const handlePlayGame = () => {
        dispatch(ShowGameLink(`${game.GameLink}${ssoToken}`));
        history.push({
            pathname: isUdcUser ? `/upgrade-games` : redirectUrl || `/generic-games-tab`,
            state: game.gamename,
        });
    };

    const handlePlayVideo = () => {
        if (game.gameVideoLink) {
            dispatch(ShowGameLink(game.gameVideoLink));
            setGameVideoPopup(true);
        }
    };

    // const handleSetCurrentGame = () => {
    //     setHasActiveCard(game?.gamename === hasActiveCard ? '' : game?.gamename);
    // };
    let isActive = game?.gamename === hasActiveCard;

    return (
        <>
            <div
                className={`w-full md:w-[29%] m-[1%] inline-block relative game-card-section bg-white shadow-sm rounded-sm transition-all duration-150 ease-in-out ${isActive ? 'active-card' : ''
                    }`}
            >
                {/* {isActive && <div className="active-card-triangle"></div>} */}
                <div className="relative">
                    <img src={game?.gameImage} style={{ width: '100%' }} alt={game?.gamename} className={`rounded-sm ${game?.gamecompleted ? 'grayscale' : ""}`} />
                    {
                        type === 'awaiting' ?
                            !game.GameLink || game?.gamecompleted ? ''
                                : <Icon onClick={handlePlayGame} name="play circle" className="playbutton" />
                            : <Icon name="check circle" className="playbutton" style={{ cursor: "default" }} />
                    }
                </div>
                <div
                    className={`card-summary pb-8 text-center transition-all duration-150 ease-in-out ${isActive ? 'bg-[#1b75bc] text-[#ffffff]' : 'bg-[#ffffff]'
                        }`}
                >
                    <div className="flex items-center justify-between pb-3 px-2">
                        <p className="uppercase text-2xl text-center font-[inherit]">{game.gamename}</p>
                        {
                            type === 'awaiting' &&
                            <span className={`video_view-link !m-0`} onClick={handlePlayVideo} >
                                <Icon name="video" className="" ></Icon>See Demo
                            </span>
                        }
                    </div>
                    <p
                        className={`text-lg leading-8 game-description font-normal text-gray-500 p-0.5 ${isActive ? 'text-[#ffffff]' : ''
                            }`}
                    >
                        {game?.gameDescription}
                    </p>
                </div>
            </div>
            {/* {isActive && (
                <div className="block float-start w-full md:w-[90%] transition-all duration-300 ease-in-out transform translate-y-4 opacity-0 animate-fadeIn mb-4 md:my-0">
                <div className="flex flex-wrap">
                    <div className="w-full hidden md:block md:w-1/4 p-2">
                        <img src={game?.gameImage} className="w-full" />
                    </div>
                    <div className="w-full md:w-3/4 p-2">
                        <p className="uppercase text-2xl font-[inherit] pb-3">Play the {game?.gamename}</p>

                        <p className={`text-lg leading-8 game-description font-normal text-gray-500 pb-4`}>
                            When the kids find a crystal cave under the Yard, they learn all about crystal molecules and dig up some sweet crystals for their collection in the museum.
                        </p>
                        <div className="flex flex-col md:flex-row gap-3">
                            {game?.gamecompleted ? (
                                <button className="px-8 py-2 rounded text-xl bg-[#1b75bc] text-[#ffff]">Finished</button>
                            ) : (
                                <button
                                    onClick={handlePlayGame}
                                    className="px-8 py-2 rounded text-xl bg-[#1b75bc] text-[#ffff]"
                                >
                                    Play
                                </button>
                            )}

                            <button
                                disabled={game?.gamecompleted}
                                onClick={handlePlayVideo}
                                className="px-8 py-2 rounded text-xl border border-[#1b75bc] text-[#1b75bc]"
                            >
                                <Icon name="video" className=""></Icon> See Demo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            )} */}
            <GameVideo GameVideoPopUp={GameVideoPopUp} setGameVideoPopup={setGameVideoPopup} />
        </>
    );
};
